<template>
    <div>
        <BaseCard>
            <template #card-body>
                <template v-if="!statusData.length">
                    <EmptyPage 
                        state="empty_custom" 
                        icon-name="report" 
                        type="data"
                        title=" No data available." 
                    />
                </template>
                <template v-else>
                    <div>
                        <slot name="header-caption" />

                        <div class="report__status stats__list">
                            <div v-for="(month, index) in months" :key="index" class="report__status__item stats__item">
                                <div class="stats__month">
                                    <p>{{ sliceMonth(month) }}</p>
                                </div>
                                <div class="stats__value">
                                    <LineProgressBar :value="calculateProgress(month)" style="height: auto;" :max-value="1000">
                                        <p class="text--xs text--semi--bold">
                                            {{ calculateProgress(month) }}
                                        </p>
                                    </LineProgressBar>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>                
            </template>
        </BaseCard>
    </div>
</template>

<script>
import { BaseCard, LineProgressBar, EmptyPage } from "@/components/ui/index";
import { months } from "@/utils/dummy";
import { 
    projectStatusMap, 
    invoiceStatusMap,
    clientStatusMap,
} from "@/utils/enums";

export default {
    name: "ReportLineChart",

    components: {
        BaseCard,
        LineProgressBar,
        EmptyPage,
    },

    props: {
        statusData: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            // months: months.map(x => x.slice(0, 3)),
            months,
            nums: [10, 20, 50, 100, 200, 300],
        };
    },

    computed: {
        statsObj() {
            const obj = {};

            for (let i = 0; i < this.statusData.length; i++) {
                const item = this.statusData[i];
                if (item) {
                    obj[item[0]] = item[1];
                }
            }

            return obj;
        },
    },

    methods: {
        calculateProgress(month) {            
            if (!month) return 0;
            const res = this.statsObj[month] || 0;  
            
            if (res > 500) return "500K+";
            
            return res;
        },

        sliceMonth(month) {
            return !month || typeof month !== "string" ? "" : month.slice(0, 3);
        },
    },
};
</script>

<style lang="scss" scoped>
    .stats {
        &__item {
            display: flex;
            align-items: center;
            margin-bottom: 0.75rem !important;
        }

        &__month {
            width: 7%;
            padding: 5px 10px;
    
            p {
                color: #666666;
                font-size: 12px;
            }
        }

        &__value {
            width: 85%;
            width: calc(100% - 10%);
        }
    }
</style>